import type { Option } from 'shared/models/common';

export function transformAmountOfKeysInput(input: string) {
  if (input === '') return input;

  let amount = parseInt(input);

  if (Number.isNaN(amount) || amount < 1) return 1;

  return amount;
}

export function getDefaultOptionValue<T extends Option<string | number>>(
  options: T[] | undefined
) {
  return Array.isArray(options) ? options[0] : undefined;
}
